export default __webpack_public_path__ + "static/media/51t.62ea51c3.jpg";